import React, { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import MobileCTABar from "./components/MobileCTABar";


const About = lazy(() => import("./pages/About"));
const BuyAFarm = lazy(() => import("./pages/BuyAFarm"));
const SellAFarm = lazy(() => import("./pages/SellAFarm"));
const FarmManagement = lazy(() => import("./pages/FarmManagement"));
const BuyingFarmGuide = lazy(() => import("./pages/BuyingFarmGuide"));
const AlmondVsPistachioGuide = lazy(() => import("./pages/AlmondVsPistachioGuide"));
const CitrusOrchardGuide = lazy(() => import("./pages/CitrusOrchardGuide"));
const CountyFarmland = lazy(() => import("./pages/CountyFarmland"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const PageLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/buy-a-farm" element={<BuyAFarm />} />
            <Route path="/sell-a-farm" element={<SellAFarm />} />
            <Route path="/farm-management" element={<FarmManagement />} />
            <Route path="/guides/buying-a-farm-central-valley" element={<BuyingFarmGuide />} />
            <Route path="/guides/almond-vs-pistachio-roi" element={<AlmondVsPistachioGuide />} />
            <Route path="/guides/buying-a-citrus-orchard" element={<CitrusOrchardGuide />} />
            <Route path="/farms-for-sale/:county" element={<CountyFarmland />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <MobileCTABar />
      </TooltipProvider>

    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
